<ng-template [ngIf]="location!='SezioneQuadroParcelle' && location !== 'default'">
<p class="col-sm-9 bloccodati"
	*ngIf="location!='SezioneEconomica' && location!='SezioneBeniImmobili' && location!='SezioneParcelle'">
	<label [attr.for]="'importo_' + randomId">{{labelInput}}</label><span *ngIf="mandatory"
		class="mandatory">*</span>
</p>
<p
	[ngClass]=" (location=='SezioneParcelle') ? 'col-sm-2' : (location!='SezioneEconomica' && location!='SezioneBeniImmobili') ? 'col-sm-3' :''">
	<ng-template
		[ngIf]="location=='SezioneEconomica' || location=='SezioneBeniImmobili' ||  location=='SezioneParcelle'">
	<label [attr.for]="'importo_' + randomId">{{labelInput}}</label> <span *ngIf="mandatory" class="mandatory">*</span>
	</ng-template>

	<input #dinput
		[attr.id]="'importo_' + randomId"
		class="form-control inputCurrency alignright" (focus)="removePoint();"
		(focusout)="validateChange();" ngbTooltip="" triggers="manual"
		#t="ngbTooltip" (keypress)="validate($event);" type="text"
		[(ngModel)]="internalValue" [placeholder]="'Inserire '+labelInput"
		[disabled]="submitPending" />
		<span style='position: absolute;top: 10%;right: 2%;'>{{currency}}</span>
		<small style="color: red;">&nbsp;
			<ng-template [ngIf]="control && !control.valid && checkFormat && _value">
			Formato non valido </ng-template>
			<ng-template
			[ngIf]="!controlValid && _value">
			<small style="color: red;">&nbsp; Valore max: {{maxValueLimit | currency: 'EUR' }} </small> </ng-template>
		</small> <input style='display: none' type="text" [(ngModel)]="_value" />
</p>
</ng-template>
<ng-template [ngIf]="location=='SezioneQuadroParcelle'"> 
<label [attr.for]="'importo_' + randomId" class="sr-only">{{labelInput}}</label>
<input #dinput
	[attr.id]="'importo_' + randomId"
	class="form-control inputCurrency alignright" (focus)="removePoint();"
	(focusout)="validateChange();" ngbTooltip="" triggers="manual"
	#t="ngbTooltip" (keypress)="validate($event);" type="text"
	[(ngModel)]="internalValue" [placeholder]="'Inserire '+labelInput"
	[disabled]="submitPending" /> <ng-template
	[ngIf]="control && !control.valid && checkFormat && _value">
<small style="color: red;">&nbsp; Formato non valido </small> </ng-template>
  <ng-template
    [ngIf]="!controlValid && _value">
    <small style="color: red;">&nbsp; Valore max: {{maxValueLimit}} </small> </ng-template>
  <input
	style='display: none' type="text" [(ngModel)]="_value" /> </ng-template>

<ng-template [ngIf]="location=='default'">
  <label [attr.for]="'default_' + randomId">{{labelInput}}</label> <span *ngIf="mandatory" class="mandatory">*</span>
  <input #dinput [attr.id]="'default_' + randomId" class="form-control inputCurrency alignright" (focus)="removePoint();"
          (focusout)="validateChange();" ngbTooltip="" triggers="manual"
          #t="ngbTooltip" (keypress)="validate($event);" type="text"
          [(ngModel)]="internalValue" [placeholder]="'Inserire '+labelInput"
          [disabled]="submitPending" /> <ng-template
  [ngIf]="control && !control.valid && checkFormat && _value">
  <small style="color: red;">&nbsp; Formato non valido </small> </ng-template>
  <ng-template
    [ngIf]="!controlValid && _value">
    <small style="color: red;">&nbsp; Valore max: {{maxValueLimit}} </small> </ng-template>
  <input style='display: none' type="text" [(ngModel)]="_value" />
</ng-template>
